<template>
  <div
    v-editable="blok"
    class="column"
    :class="styleClasses"
    :style="styleFromProps">
    <component
      :key="blok._uid"
      v-for="blok in blok.body"
      :blok="blok"
      :publishedAt="publishedAt"
      :is="blok.component">
    </component>
  </div>
</template>

<script>
export default {
  name: 'blok-column',
  props: ['blok', 'publishedAt'],
  computed: {
    styleFromProps() {
      const bg = this.blok.background
      return bg ? `background:${bg};` : ''
    },
    styleClasses() {
      let appliedClasses = this.blok.width || 'col-md-6'
      if (this.blok.style) {
        appliedClasses = appliedClasses + ' ' + this.blok.style
      }
      return appliedClasses
    },
  },
}
</script>

<style scoped>
.shadowed-card {
  height: 100%;
  padding: 10px 20px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
}
</style>
